export default __webpack_public_path__ + "static/media/IMG-20240708-WA0023.1261b8bb.jpg";